import type { DynamicPageType } from '@wix/wix-data-client-common'

export const pageTypeToBiValue = (pageType: DynamicPageType): string =>
  pageType === 'index' ? 'list_page' : 'item_page'
